/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBalanceUpdateResponse {
    getFixupPrototypeFunction() { return MasterAccountBalanceUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBalanceUpdateResponse>): MasterAccountBalanceUpdateResponse {
        let obj = Object.assign(new MasterAccountBalanceUpdateResponse(), model);
        MasterAccountBalanceUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBalanceUpdateResponse>): MasterAccountBalanceUpdateResponse {
        if (!model) return null;
        return MasterAccountBalanceUpdateResponse.newInstance(<MasterAccountBalanceUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBalanceUpdateResponse) {
        if (!obj) return;

        models.MasterAccountBalanceUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBalanceUpdateResponse): boolean {
        Object.setPrototypeOf(obj, MasterAccountBalanceUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.previous_balance === undefined) {
            this.previous_balance = 0;
        }
        if (this.current_balance === undefined) {
            this.current_balance = 0;
        }
    }

    /**
     * Transaction id for the balance update.
     */
    transaction_id: string;

    /**
     * Balance amount before the update in master account balance.
     */
    previous_balance: number;

    /**
     * Balance amount after the update in master account balance.
     */
    current_balance: number;

}
